// extracted by mini-css-extract-plugin
export default {"card":"soon-module__card--qB7aZ","imgContainer":"soon-module__imgContainer--KRe8_","bubble":"soon-module__bubble--Sl2ol"};